import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { MdArrowOutward } from "react-icons/md";
// import { BsArrowUpRightCircle } from "react-icons/bs";
import { motion } from "framer-motion";
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import FollowUs from "../Footer/FollowUs";
import LetsGet from "../Footer/LetsGet";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
// import "./fonts.css";

// --- Carousel Data ---
const carouselImages = [ 
  {
    id: 1,
    src: "https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0",
    title: "Soham Villas",
    year: "2023",
    category: "Interior, Architecture Firm",
  },
  {
    id: 2,
    src: "https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0",
    title: "Soham Villas",
    year: "2023",
    category: "Interior, Architecture Firm",
  },
  {
    id: 3,
    src: "https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0",
    title: "Soham Villas",
    year: "2023",
    category: "Interior, Architecture Firm",
  },
  {
    id: 4,
    src: "https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0",
    title: "Soham Villas",
    year: "2023",
    category: "Interior, Architecture Firm",
  },
  {
    id: 5,
    src: "https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0",
    title: "Soham Villas",
    year: "2023",
    category: "Interior, Architecture Firm",
  },
  {
    id: 6,
    src: "https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0",
    title: "Soham Villas",
    year: "2023",
    category: "Interior, Architecture Firm",
  },
  {
    id: 7,
    src: "https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0",
    title: "Soham Villas",
    year: "2023",
    category: "Interior, Architecture Firm",
  },
  {
    id: 8,
    src: "https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0",
    title: "Soham Villas",
    year: "2023",
    category: "Interior, Architecture Firm",
  },
  {
    id: 9,
    src: "https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0",
    title: "Soham Villas",
    year: "2023",
    category: "Interior, Architecture Firm",
  },
];

//animation
// const fadeLeft = {
//   hidden: { opacity: 0, x: -80 },
//   visible: {
//     opacity: 1,
//     x: 0,
//     transition: { duration: 1, ease: "easeOut" },
//   },
// };

const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -60, // ⬅️ comes from left
  },
  visible: (delay = 0) => ({
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      delay: delay,
    },
  }),
};


// const fadeRight = {
//   hidden: { opacity: 0, x: 80 },
//   visible: {
//     opacity: 1,
//     x: 0,
//     transition: { duration: 1, ease: "easeOut" },
//   },
// };

const fadeRight = {
  hidden: {
    opacity: 0,
    x: 60,
  },
  visible: (delay = 0) => ({
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      delay: delay,
    },
  }),
};

  
const RecentWorksCarousel = () => {
  return (
    <section className="py-12 relative">
      <h2 className="text-5xl heading tracking-widest text-center mb-16 uppercase text-[#252525]">
        Recent Works
      </h2>

      <div className="recent-works-wrapper relative w-full max-w-[96rem] mx-auto px-0">
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          centeredSlides={true}
          spaceBetween={30}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 3 },
            2560: { slidesPerView: 5 },
          }}
          className="recent-works-swiper"
        >
          {carouselImages.map((work) => (
            <SwiperSlide key={work.id} className="flex justify-center">
              <div className="flex flex-col items-center justify-center">
                {/* <img
                  src={work.src}
                  alt={work.title}
                  className="work-image object-cover rounded-none shadow-md  transition-all duration-500"
                /> */}
                <img
                  src={work.src}
                  alt={work.title}
                  className="work-image object-cover rounded-none
                            shadow-none hover:shadow-2xl
                            transition-shadow duration-500 ease-in-out"
                />

                <div className="text-center mt-4 ">
                  <p className="font-semibold  text-lg text-[#1A1919] bodyFont">
                    {work.title}
                  </p>
                  <p className="text-sm text-gray-900 extraFont">
                    {work.year} | {work.category}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-button-prev-custom absolute z-20 cursor-pointer p-3 left-1 md:left-[29%] lg:left-[30%] xl:left-[30%] top-1/2 -translate-y-1/2">
          <FaArrowLeft className="text-black text-xl md:text-2xl" />
        </div>
        <div className="swiper-button-next-custom absolute z-20 cursor-pointer p-3 right-1 md:right-[29%] lg:right-[30%] xl:right-[30%] top-1/2 -translate-y-1/2">
          <FaArrowRight className="text-black text-xl md:text-2xl" />
        </div>
      </div>

      <style>{`
        .recent-works-swiper .swiper-slide {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          transition: transform 0.4s ease, opacity 0.4s ease;
          transform: scale(0.85);
          opacity: 0.8;
        }
        .recent-works-swiper .swiper-slide-active {
          transform: scale(1);
          opacity: 1;
        }
        .recent-works-swiper .swiper-slide-next,
        .recent-works-swiper .swiper-slide-prev {
          transform: scale(0.9);
          opacity: 0.9;
        }
        .recent-works-swiper .swiper-slide img {
          width: 100%;
          max-width: 320px;
          height: auto;
          border-radius: 0;
          transition: all 0.5s ease;
        }
        @media (max-width: 768px) {
          .recent-works-swiper .swiper-slide img { max-width: 250px; }
        }
       
        @media (min-width: 2560px) {
          .recent-works-wrapper { max-width: 155rem !important; padding-left: 2rem !important; padding-right: 2rem !important; }
          .recent-works-swiper .swiper-slide img { max-width: 360px; margin: 0 30px; }
          .swiper-button-prev-custom { left: 39% !important; }
          .swiper-button-next-custom { right: 39% !important; }
        }
      `}</style>
    </section>
  );
};



const SocialMedia = () => (
  <div className="main-screen-container bg-white overflow-x-hidden">

    <div className="min-h-screen font-sans relative overflow-x-hidden">
      <Header />
      <div
        className="relative flex flex-col items-center justify-center text-left pt-16 pb-32 px-4 sm:px-6 md:px-16 lg:px-24 xl:px-32 2xl:px-40 bg-center bg-cover min-h-screen"
        style={{ backgroundImage: "url('../assets/openBG.png')" }}
      >
        <div className="absolute inset-0 z-0"></div>

        {/* MOBILE */}
        <div className="relative z-10 text-left md:text-left max-w-4xl block lg:hidden">
          <div className="relative pl-6 py-1 sm:py-3">
            <motion.div
              initial={{ height: 0 }}
              whileInView={{ height: "30%" }}
              transition={{ duration: 1.2, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="absolute left-0 top-0 w-[2px] bg-[#F56E0F] flex flex-col items-center"
            >
              <div className="flex-1 w-full bg-[#F56E0F]"></div>
              <div className="w-2 h-2 rounded-full bg-[#F56E0F] mt-1"></div>
            </motion.div>
            <p className="extraFont text-[0.8rem] sm:text-base md:text-xl leading-relaxed  text-[#1A1919]">
              From scroll-stopping content to viral campaigns
              <br />
              we craft stories that spark action, not just
              <br />
              attention.
            </p>
            <h1 className="heading animate-zoom-in text-[4rem] sm:text-[4rem] md:text-[7rem] lg:text-[10rem] xl:text-[12rem]  leading-none tracking-tight mt-4">
              <span className="text-[#F56E0F] block ">We Turn Clicks</span>
              <span className="text-[#3A2727] block mt-2">Into Clients</span>
            </h1>
            
            <p className="extraFont text-[0.8rem] sm:text-base md:text-xl text-[#1A1919]  mt-2">
              Based in Rajkot
            </p>
          </div>
        </div>

        {/* DESKTOP */}
        <div className="relative z-10 text-left md:text-left max-w-4xl hidden lg:block">
          <div className="relative pl-6 py-2 pt-5">
            <motion.div
              initial={{ height: 0 }}
              whileInView={{ height: "20%" }}
              transition={{ duration: 1.9, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="absolute left-0 top-4 w-[2px] bg-[#F56E0F] flex flex-col items-center"
            >
              <div className="flex-1 w-full bg-[#F56E0F]"></div>
              <div className="w-2 h-2 rounded-full bg-[#F56E0F] mt-1"></div>
            </motion.div>
            <p className="extraFont text-[0.8rem] sm:text-base md:text-xl leading-relaxed  text-[#1A1919]">
              From scroll-stopping content to viral campaigns
              <br />
              we craft stories that spark action, not just
              <br />
              attention.
            </p>
            <div>
            <h1 className="heading text-[4rem] sm:text-[4rem] md:text-[7rem] lg:text-[10rem] xl:text-[12rem] animate-zoom-in leading-none tracking-tight mt-4">
              <span className="text-[#F56E0F] block">We Turn Clicks</span>
              <span className="text-[#3A2727] block mt-2">Into Clients</span>
            </h1>
            </div>
            <style jsx global>{`
              @keyframes zoomInGrow {
                0% {
                  opacity: 0;
                  transform: scale(0.9);
                }
                100% {
                  opacity: 1;
                  transform: scale(1);
                }
              }

              .animate-zoom-in {
                animation: zoomInGrow 1.2s ease-out forwards;
              }
            `}</style>

            <p className="extraFont text-[0.8rem] sm:text-base md:text-xl text-[#1A1919]  mt-2">
              Based in Rajkot
            </p>
            
          </div>
        </div>
        <div className=" absolute right-4 md:right-10 lg:right-16 lg:bottom-16 bottom-5 text-right z-10">
          <p className="inter text-[0.8rem] sm:text-base md:text-lg text-[#1A1919]">
            Social Media
          </p>
        </div>
      </div>

      <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 pt-12 lg:pt-24 pb-8 grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-20 overflow-x-hidden">
        <div>
        {/* <motion.div
          variants={fadeLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          > */}
          <h2 className="heading text-2xl sm:text-3xl md:text-4xl text-[#252525] tracking-widest mb-6 ml-6 text-left">
            OUR SERVICES
          </h2>
          <ul className="bodyFont space-y-3 text-base sm:text-lg md:text-lg  text-left text-[#1A1919]">
            {[
              "Strategy & Management",
              "Content Creation",
              "Hashtag Research",
              "Influencer Collaborations",
              "Performance Marketing",
              "Community Engagement & Growth",
              "Facebook & Instagram Boosting",
              "YouTube Video Ad Management",
            ].map((item, index) => (
              <li
                key={index}
                className="flex items-center justify-start gap-2 group cursor-pointer"
              >
                <MdArrowOutward className="text-lg sm:text-xl opacity-0 transition-all duration-300 group-hover:opacity-100" />
                <span className="transition-all duration-300 group-hover:font-bold inline-block">
                  {item}
                </span>
              </li>
            ))}
          </ul>
          {/* </motion.div> */}
        </div>

        {/* <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-8 lg:mt-0">
          <img
            src="https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0"
            alt="Service"
            className="h-[200px] sm:h-[250px] md:h-[350px] lg:h-[450px] xl:h-[500px] w-full object-cover shadow-lg"
          />
          <img
            src="https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0"
            alt="Service"
            className="h-[200px] sm:h-[250px] md:h-[350px] lg:h-[450px] xl:h-[500px] w-full object-cover shadow-lg"
          />
        </div> */}
        {/* <motion.div
                    variants={fadeRight}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-8 lg:mt-0"> */}
        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-8 lg:mt-0">
        <motion.div
            variants={fadeRight}
            custom={0}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <img
              src="https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0"
              alt="Service"
              className="h-[200px] sm:h-[250px] md:h-[350px] lg:h-[450px] xl:h-[500px] w-full object-cover shadow-lg border-2 border-transparent hover:border-[#3A2727] transition-all duration-300"
            />
          </motion.div>

          <motion.div
            variants={fadeRight}
            custom={0.5}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <img
              src="https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0"
              alt="Service"
              className="h-[200px] sm:h-[250px] md:h-[350px] lg:h-[450px] xl:h-[500px] w-full object-cover shadow-lg border-2 border-transparent hover:border-[#3A2727] transition-all duration-300"
            />
          </motion.div>
      </div>
      {/* </motion.div> */}
      </div> 

      <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 pt-12 lg:pt-24 pb-8 grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-20 overflow-x-hidden">
        <div className="flex flex-col justify-center lg:order-2 order-1 lg:pl-8">
        {/* <motion.div
                    variants={fadeRight}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    className="flex flex-col justify-center lg:order-2 order-1 lg:pl-8"> */}
          <p className="extraFont text-base sm:text-lg md:text-xl  text-[#1A1919] leading-relaxed mb-4">
            We’re not just managing your social media, we’re building your
            digital presence with purpose. At Open Studios, we blend design, and
            motion to create campaigns that convert, and elevate your brand
            across platforms.
          </p>
          <button className="flex items-center rounded-full overflow-hidden group mt-4 -ml-5">
            <div className="text-[#1A1919] inter px-6 py-2 rounded-full transition-all duration-300">
              Explore All
            </div>

            <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#ED772F] transition-all duration-300">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ED772F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
              >
                <line x1="7" y1="17" x2="17" y2="7" />
                <polyline points="7 7 17 7 17 17" />
              </svg>
            </div>
            
          </button>
          {/* </motion.div> */}
        </div>
        <div className="lg:col-span-2 grid gap-6 order-2 lg:order-1">
          
          {/* <motion.div
          variants={fadeLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6"
          > */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-10">
          <motion.div
            variants={fadeLeft}
            custom={0.3}   
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <img
              src="https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0"
              alt="Service 4"
              className="h-[250px] sm:h-[300px] md:h-[350px] lg:h-[450px] xl:h-[500px] w-full object-cover shadow-lg border-2 border-transparent hover:border-[#3A2727] transition-all duration-300"
            />
          </motion.div>
            <motion.div
              variants={fadeLeft}
              custom={0}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <img
                src="https://hips.hearstapps.com/hmg-prod/images/screen-shot-2024-01-25-at-12-37-59-pm-65b29c797364e.png?crop=0.617xw:1.00xh;0.0170xw,0"
                alt="Service 3"
                className="h-[250px] sm:h-[300px] md:h-[350px] lg:h-[450px] xl:h-[500px] w-full object-cover shadow-lg border-2 border-transparent hover:border-[#3A2727] transition-all duration-300"
              />
            </motion.div>


          </div>
          {/* </motion.div> */}
        </div>
      </div>

        <div className="w-full overflow-hidden mb-5">
        <div className="slider">
            <div className="slide-track">
                {[
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                "../assets/logo-1.png",
                ]
                .concat([
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                    "../assets/logo-1.png",
                ])
                .map((src, i) => (
                    <div className="slide" key={i}>
                    <img src={src} alt="logo" className="slide-img" />
                    </div>
                ))}
            </div>

            <style>
                {`
                .slider {
                    background: white;
                    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.125);
                    height: 120px;
                    overflow: hidden;
                    position: relative;
                    width: 100%;
                }

                .slider::before,
                .slider::after {
                    content: "";
                    position: absolute;
                    width: 200px;
                    height: 100%;
                    z-index: 2;
                    background: linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
                    top: 0;
                }

                .slider::after {
                    right: 0;
                    transform: rotateZ(180deg);
                }

                .slider::before {
                    left: 0;
                }

                .slide-track {
                    display: flex;
                    width: calc(250px * 28);
                    animation: scroll 40s linear infinite;
                }

                .slide {
                    width: 250px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                @keyframes scroll {
                    0% {
                    transform: translateX(0);
                    }
                    100% {
                    transform: translateX(calc(-250px * 14));
                    }
                }

                /* Grayscale hover effect */
                .slide-img {
                    height: 60px;
                    object-fit: contain;
                    filter: grayscale(100%);
                    transition: all 0.5s ease-in-out;
                }

                .slide-img:hover {
                    filter: grayscale(0%);
                    transform: scale(1.1);
                }
                `}
            </style>
            </div>
      </div>

      <div className="px-2 sm:px-6 md:px-8 lg:px-12 xl:px-16 py-10 lg:py-5 grid lg:grid-cols-2 gap-12 lg:gap-44 items-center overflow-x-hidden">
        <motion.div
                    variants={fadeLeft}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
        >
        <img
          src="https://st5.depositphotos.com/22220764/63736/i/450/depositphotos_637363472-stock-photo-warm-cozy-living-room-interior.jpg"
          alt="Feature"
          className="w-full object-cover shadow-lg"
        />
        </motion.div>

        {/* <div className="flex flex-col justify-center"> */}
        <motion.div
                    variants={fadeRight}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    className="flex flex-col justify-center">
          <p className="bodyFont text-lg  text-[#1A1919] leading-relaxed mb-6 font-semibold sm:w-[350px] w-[300px]">
            From strategy to scroll-stopping execution, we build digital
            narratives that engage your audience where it matters most.
          </p>
          <button className="inter flex items-center rounded-full overflow-hidden group mt-4">
            <div className="text-[#1A1919] px-2 py-2 rounded-full transition-all duration-300">
              Read More
            </div>
            <div className=" w-10 h-10 flex items-center justify-center rounded-full border border-[#ED772F] transition-all duration-300">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ED772F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
              >
                <line x1="7" y1="17" x2="17" y2="7" />
                <polyline points="7 7 17 7 17 17" />
              </svg>
            </div>
          </button>
          </motion.div>
        {/* </div> */}
      </div>

      <RecentWorksCarousel />

      <LetsGet />
      <FollowUs />
      <Footer />
    </div>
  </div>
);

export default SocialMedia;
